import myAxios from './myAxios';
import * as actions from './actions';

export function fetchDrawerContent (type, data) {
  return function (dispatch) {
    dispatch({type: 'FETCH_DRAWER_CONTENT', payload: type});
    if (type === 'reportMenu') {
      fetchReportMenuContent(dispatch);
    } else {
      fetchCurrentEpisodeCommentsContent(dispatch, data);
    }
  };
}

export function fetchReportMenuContent (dispatch) {
  myAxios.get(routes().violation + '/content_categories')
    .then((response) => {
      dispatch({type: 'FETCH_REPORT_MENU_CONTENT_FULFILLED', payload: response.data});
      dispatch({type: 'FETCH_DRAWER_CONTENT_FULFILLED'});
    })
    .catch((err) => {
      dispatch({type: 'FETCH_REPORT_MENU_CONTENT_REJECTED', payload: err});
      dispatch({type: 'FETCH_DRAWER_CONTENT_REJECTED', payload: err});
    });
}
export function fetchCurrentEpisodeCommentsContent (dispatch, data) {
  return myAxios.get(
    routes().get_episode + data.episode_id + '/pop_comments',
    { params: { page_number: data.page_number, per_page: data.per_page } }
  )
    .then((response) => {
      if (data.page_number > 1) {
        dispatch({type: 'FETCH_MORE_COMMENTS_FULFILLED', payload: response.data});
        dispatch({type: 'APPEND_CURRENT_EPISODE_COMMENTS', comments_to_load: response.data.pop_comments});
      } else {
        dispatch({type: 'FETCH_COMMENT_LIST_CONTENT_FULFILLED', payload: response.data});
        dispatch({type: 'SET_CURRENT_EPISODE_COMMENTS', current_episode_comments: response.data.pop_comments});
      }
      dispatch({type: 'HIDE_SMALL_SPINNER'});
      dispatch({type: 'FETCH_DRAWER_CONTENT_FULFILLED'});
      return response.data.pop_comments;
    });
}

export function closeDrawer () {
  return function (dispatch) {
    dispatch({type: 'HIDE_DRAWER_CONTENT'});
  };
}

export function openDrawer (type) {
  return function (dispatch) {
    dispatch({type: 'SHOW_DRAWER_CONTENT', payload: type});
  };
}

export function loadMoreComments (episodeId, pageNumber = 1) {
  return function (dispatch) {
    dispatch({type: 'FETCH_DRAWER_CONTENT'});
    fetchCurrentEpisodeCommentsContent(dispatch, { episode_id: episodeId, page_number: pageNumber });
  };
}

export function openSocialDropdown () {
  return function (dispatch) {
    dispatch({type: 'SHOW_SOCIAL_DROPDOWN'});
  };
}

export function closeSocialDropdown () {
  return function (dispatch) {
    dispatch({type: 'HIDE_SOCIAL_DROPDOWN'});
  };
}

export function selectReportCategory (id) {
  return function (dispatch) {
    dispatch({ type: 'REPORT_CATEGORY_SELECTED', payload: id });
  };
}

export function submitReport (reportContext) {
  return function (dispatch) {
    myAxios.post(routes().violation + '/report_content', reportContext)
      .then((response) => {
        dispatch({type: 'HIDE_DRAWER_CONTENT'});
        setNoticeSuccess(reportContext.violationReported);
      })
      .catch((error) => {
        if (error.response.data.fields[0].violation_category_id) {
          setNoticeError(reportContext.noCategorySelected)
        }
      });
  };
}

export function episodeToggleLike (episodeId) {
  return function (dispatch) {
    myAxios.post(routes().get_episode + episodeId + '/like')
      .then((response) => {
        dispatch({type: 'EPISODE_LIKE_TOGGLE_SUCCEED'});
      })
      .catch((err) => {
        dispatch({type: 'EPISODE_LIKE_TOGGLE_SUCCEED', payload: err});
      });
  };
}
